module.exports = __webpack_public_path__ + "static/media/example.516dc792.jpg";